// extracted by mini-css-extract-plugin
module.exports = {"back":"back___27ke5","paperTitle":"paperTitle___3rNJ1"};